import _objectWithoutProperties from "/codebuild/output/src1506462530/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["fieldName", "value", "label", "onChange"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React, { useState } from 'react';
import { HiddenField } from '@guryou/html-components';
import { KeyboardTimePicker } from '@material-ui/pickers';
import moment from 'moment';
import PropTypes from 'prop-types';
const TIME_FORMAT = 'HH:mm';
const TimePickers = _ref => {
  let {
      fieldName,
      value,
      label,
      onChange
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const [defaultValue, setDefaultValue] = useState(moment(value, TIME_FORMAT));
  const onChangeHandler = date => {
    setDefaultValue(date);
    onChange && onChange(date);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HiddenField, {
    name: fieldName,
    value: defaultValue ? defaultValue.format(TIME_FORMAT) : ''
  }), /*#__PURE__*/React.createElement(KeyboardTimePicker, _extends({}, rest, {
    style: {
      margin: '1rem 0',
      width: '40%',
      padding: '4px 0'
    },
    InputProps: {
      name: null
    },
    autoOk: true,
    label: label,
    ampm: false,
    value: defaultValue,
    minutesStep: 5,
    onChange: onChangeHandler
  })));
};
TimePickers.propTypes = {
  disablePast: PropTypes.bool,
  format: PropTypes.string,
  fieldName: PropTypes.string
};
TimePickers.defaultProps = {
  disablePast: true
};
export default TimePickers;